<template>
  <section class="section-history">
    <div
      v-if="mixins_global_search_historyList && mixins_global_search_historyList.length > 0"
      class="history-menu"
    >
      <h3 class="history">
        <i class="fal fa-history"></i> ค้นหาล่าสุด
      </h3>
      <h3 class="trash" @click="clearHistory()">ลบประวัติ</h3>
    </div>
    <ul class="history-list">
      <li
        data-action="recent_search"
        v-for="item in mixins_global_search_historyList"
        :key="item"
        @click="clickHistory(item)"
      >{{item}}</li>
    </ul>
    <toast
      v-if="toggleToast"
      :toggleToast="toggleToast"
      :toastType="toastType"
      :options="options"
      @confirm-toast="confirmToast"
    ></toast>
  </section>
</template>
<script>
import GlobalSearchHistory from "../../mixins/global-search-history";
import Toast from "../../../components/miniapp/global/Toast.vue";

export default {
  components: {
    Toast
  },
  data() {
    return {
      options: {
        dialog: {
          title: "",
          body: "ต้องการลบข้อมูลการค้นหาใช่หรือไม่",
          action: [
            {
              action1: "ใช่",
              action2: "ไม่ใช่"
            }
          ],
          duration: 0
        }
      },
      toggleToast: false,
      toastType: ""
    };
  },
  mixins: [GlobalSearchHistory],
  created() {
    this.mixins_global_search_getHistory();
  },
  methods: {
    clickHistory(values) {
      this.$emit("click-history", { text: values });
    },
    clearHistory() {
      this.toastType = "confirmation";
      this.toggleToast = true;
    },
    confirmToast(val) {
      if (val) {
        this.mixins_global_search_clearHistory(val);
      }
      this.toggleToast = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.section-history {
  .history-menu {
    @extend %container-style;
    background-color: #fdfdfd;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 20px;
    h3 {
      font-size: 12px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $color-secondary-text;
      &.history {
        @include finCol(6, 12, 0px, middle, true, true);
        text-align: left;
      }
      &.trash {
        @include finCol(6, 12, 0px, middle, true, true);
        text-align: right;
      }
    }
  }

  .history-list {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      @extend %container-style;
      padding: 20px;
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $color-normal-text;

      border-bottom: 1px solid $color-border;
      &:first-child {
        border-top: 1px solid $color-border;
      }
    }
  }
}
</style>